import styled from 'styled-components';

import Card from 'components/insights/layout/Card';
import AccessGuard from 'components/shared/AccessGuard';
import Button from 'components/shared/Button';
import { PERMISSIONS } from 'models/Profile';
import { colors } from 'styles/theme/colors';
import { BodySmall, H3 } from 'styles/typography';
import PlusIcon from 'svg/PlusIcon';
import UserXIcon from 'svg/UserXIcon';

export type DenialListEmptyStateProps = {
  onAdd: () => void;
};

export default function DenialListEmptyState({ onAdd }: DenialListEmptyStateProps) {
  return (
    <Container data-testid='denial-list-empty-state'>
      <UserXIcon width={24} height={24} style={{ color: colors.blue100 }} />
      <H3>No Denial List Entries</H3>
      <BodySmall color={colors.black100}>No patients have been added to your denial list yet.</BodySmall>
      <AccessGuard accessor={PERMISSIONS.denialListItemCreate}>
        <AddButton variant='primary' onClick={onAdd}>
          <PlusIcon width={16} height={16} />
          Add New Entry
        </AddButton>
      </AccessGuard>
    </Container>
  );
}

const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px;
  text-align: center;
`;

const AddButton = styled(Button)`
  margin-top: 16px;
`;
